import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export const useCatalogCourseNavigate = () => {
  const navigate = useNavigate()

  const navigateToCourse = useCallback(
    (objectiveId: string = '', replace = true) => {
      navigate(`/catalog/${objectiveId}`, { replace })
    },
    [navigate],
  )

  return { navigateToCourse }
}
